import React from 'react';

import ErrorPage from '@/components/errors/ErrorPage.jsx';

const Error404 = () => {
    return (
        <ErrorPage
            title="Сторінку не знайдено"
            message="Сторінка, яку ви шукаєте, не існує або була переміщена."
            showReload={false}
        />
    );
};

export default Error404;
